import { useContext } from 'react';

import { LayerContext } from 'state/LayerContext';
import { useGetLayerQuery, useGetRouteInfoQuery } from 'state/apiSlice';
import { useAppSelector } from 'state/hooks';
import {
  selectProject,
  selectRouteSelection,
  selectSegmentId,
} from 'state/workflowSlice';

import { routeSelectionIsSavedRoute } from 'features/common/hooks/useRouteInfo';
import { getRouteForSparseSegments } from 'features/map/utils/route_utils';

export function useSegmentRouteInfo() {
  const routeSelection = useAppSelector(selectRouteSelection);
  const project_slug = useAppSelector(selectProject);
  const selectedSegment = useAppSelector(selectSegmentId);

  const { layer } = useContext(LayerContext);
  const { currentData: layerData } = useGetLayerQuery(layer, { skip: !layer });

  let routeSegmentIds = [selectedSegment];
  if (routeSelection?.length > 0 && layerData) {
    routeSegmentIds = getRouteForSparseSegments(
      layerData.routing,
      routeSelection,
    );
  }
  const { currentData: routeData } = useGetRouteInfoQuery(
    {
      project_slug,
      segment_ids: routeSegmentIds,
      layer_id: layer,
    },
    {
      skip:
        (routeSelection && routeSelectionIsSavedRoute(routeSelection)) ||
        !selectedSegment,
    },
  );
  return routeData?.feature;
}
